import styled from '@emotion/styled';

import { tableFormatPhoneNumber } from '../../../utils/utils';

interface TablePhoneFormatterProps {
  data?: Record<string, any>;
  dataKey?: string;
}

const TablePhoneFormatter: React.FC<TablePhoneFormatterProps> = ({
  data,
  dataKey,
}) => {
  const label = data && data[dataKey ?? ''];
  return <Container>{tableFormatPhoneNumber(label)}</Container>;
};

export default TablePhoneFormatter;

const Container = styled.div`
  word-break: break-word;
  width: 100%;
`;
